import { SubMeteringSystem } from "../../../types/api.types";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { SYSTEMS } from "../ThirdPartySystems.constants";
import type { ConfigurationData } from "../ThirdPartySystems.types";

type SubMeteringFormFields =
  | "clientId"
  | "name"
  | "password"
  | "subMeteringSystem"
  | "token"
  | "url"
  | "username";

type SubMeteringFormFieldData = {
  [K in SubMeteringFormFields]: FormInputData<ConfigurationData, K>;
};

export const SUB_METERING_FORM_FIELD_DATA: SubMeteringFormFieldData = {
  subMeteringSystem: {
    name: "subMeteringSystem",
    type: "select",
    label: "Untermesssystem",
    required: true,
    data: SYSTEMS,
    id: "id_form_sub_metering_system"
  },
  name: {
    name: "name",
    type: "text",
    label: "Name der Konfiguration",
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet",
    required: false
  },
  url: {
    name: "url",
    type: "text",
    label: "URL des Untermesssystems",
    helpText:
      "Die URL unter welcher Ihr System erreicht werden kann\n###### Beispiel Rotorsoft\n* https://beispiel.rotorsoft.net:8443\n###### Beispiel WIS\n* https://wis.de/wis/rest",
    required: false
  },
  username: {
    name: "username",
    type: "text",
    label: "Benutzername",
    helpText:
      "Der Benutzername, mit dem sich opti.node im Drittsystem authentifizieren soll.",
    required: false
  },
  password: {
    name: "password",
    type: "password",
    label: "Passwort",
    helpText:
      "Das Passwort, mit dem sich opti.node im Drittsystem authentifizieren soll.",
    required: false
  },
  token: {
    name: "token",
    type: "password",
    label: "Token",
    helpText:
      "Der Token, mit dem sich opti.node im Drittsystem authentifizieren soll.",
    required: false
  },
  clientId: {
    name: "clientId",
    type: "text",
    label: "Client ID",
    helpText:
      "Die Client ID, mit der sich opti.node im Drittsystem authentifizieren soll.",
    required: false
  }
} as const;

export const FIELDS_FOR_SYSTEM: Record<
  SubMeteringSystem,
  Array<keyof ConfigurationData>
> = {
  [SubMeteringSystem.RotorsoftDrehpunkt]: ["url", "username", "password"],
  [SubMeteringSystem.WisSoftenergy]: ["url", "username", "password"],
  [SubMeteringSystem.NavigatorSiemens]: ["clientId", "username", "password"],
  [SubMeteringSystem.Qivalo]: ["username", "password"],
  [SubMeteringSystem.WonderWindguard]: ["username", "password"],
  [SubMeteringSystem.BreezeGreenbyte]: ["username", "token"],
  [SubMeteringSystem.WeoBytemee]: [],
  [SubMeteringSystem.Wattline]: ["username", "token"],
  [SubMeteringSystem.Metiundo]: ["username", "password"]
};

export const NEW_CONFIGURATION_DEFAULT_VALUES: Partial<ConfigurationData> = {
  name: "",
  url: null,
  username: "",
  password: "",
  token: null,
  clientId: null
};
